import HardwareWalletSigningModal from './HardwareWalletSigningModal'

export default HardwareWalletSigningModal
